module.exports = __webpack_public_path__ + "img/contact.4eb430e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/contact.png
// module id = SPz/
// module chunks = 1